getExperiment = require 'lib/experiments/simple-test'
t = require('views/internal/teacup-with-helpers')('filter_cards')

module.exports = ->
  if getExperiment('improvedBoardSearchFormFactor').get('variation') == 'searchInput'
    t.div '.js-search-input-view'
  else
    t.input '.js-input.js-autofocus', { type: 'text', attr: 'title', value: t.mustacheVar('title'), style: 'margin-bottom: 0;' }

  t.div '.js-filter-search-results'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/filter_cards.coffee